export enum BetStatus {
  Lose,
  Win,
  Pending,
  Canceled,
  Unknown,
  Calculation,
  OnCancel,
}
